// Module
var code = `<!-- Modal backdrop -->
<div class="modal-backdrop fade" ng-cloak ng-if="\$ctrl.showConflictModal" ng-class="{'show': \$ctrl.showConflictModal}">
</div>
<!-- Conflict Modal -->
<div class="modal fade" ng-cloak ng-class="{'show': \$ctrl.showConflictModal}"
    ng-style="{'display': \$ctrl.showConflictModal ? 'block' : 'none'}" tabindex="-1" role="dialog"
    aria-labelledby="conflictModalLabel" ng-attr-aria-hidden="{{!\$ctrl.showConflictModal}}">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-warning text-dark">
                <h5 class="modal-title" id="conflictModalLabel">
                    <i class="fas fa-exclamation-triangle"></i> Replace Existing File<span
                        ng-if="\$ctrl.conflicts.length > 1">s</span>?
                </h5>
                <button type="button" class="btn-close" ng-click="\$ctrl.cancelUpload()" aria-label="Close"></button>
            </div>
            <div class="modal-body" ng-if="\$ctrl.conflicts.length > 0">
                <p class="mb-3">The following file<span ng-if="\$ctrl.conflicts.length > 1">s</span> will be replaced:
                </p>
                <div class="table-responsive mb-3">
                    <table class="table table-sm table-striped align-middle mb-0">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Orientation</th>
                                <th>File</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="conflict in \$ctrl.conflicts">
                                <td class="text-truncate" style="max-width: 250px;" title="{{conflict.parsed.name}}">
                                    <strong>{{conflict.parsed.name}}</strong></td>
                                <td><span class="badge bg-secondary">{{\$ctrl.getOrientationText({orientation:
                                        conflict.existingAsset.orientation})}}</span></td>
                                <td class="text-truncate text-muted" style="max-width: 280px;"
                                    title="{{conflict.file.name}}"><small>{{conflict.file.name}}</small></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p class="text-muted small mb-0">
                    <i class="fas fa-info-circle"></i> The old asset<span ng-if="\$ctrl.conflicts.length > 1">s</span>
                    will be removed from the library and replaced with the new file<span
                        ng-if="\$ctrl.conflicts.length > 1">s</span>.
                </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" ng-click="\$ctrl.cancelUpload()">
                    <i class="fas fa-times"></i> Cancel All </button>
                <button type="button" class="btn btn-warning" ng-click="\$ctrl.confirmReplace()">
                    <i class="fas fa-check"></i> Replace All </button>
            </div>
        </div>
    </div>
</div>`;
// Exports
export default code;